var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOvertime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54883 6.21143V30.2114H29.4588V13.5363H21.0903V6.21143H8.54883Z",
    fill: "#FF80D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0608 13.5298H29.5487L21.0608 6.21143V13.5298Z",
    fill: "#EA24AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(8.54883 6.21143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOvertime);
export default __webpack_public_path__ + "static/media/icon_overtime.300950e219b07858d2cf9b2f950a3bda.svg";
export { ForwardRef as ReactComponent };